export interface StatisticsHoursParams {
  hours_start?: string;
  hours_end?: string;
  weekend_hours_start?: string;
  weekend_hours_end?: string;
  timezone?: string;
}
const TIME = "(?:[01]\\d|2[0-3]):[0-5]\\d";
const HOURS = new RegExp(`^${TIME}-${TIME}(~${TIME}-${TIME})?$`);
export function normalizeStatisticsHours(value: unknown): string | undefined {
  return typeof value === "string" && HOURS.test(value) ? value : undefined;
}
/** The URL stores wall-clock windows; requests bind the same browser zone as chart buckets. */
export function statisticsHoursParams(value: string | undefined): StatisticsHoursParams {
  const normalized = normalizeStatisticsHours(value);
  if (!normalized) return {};
  const [daily, weekend] = normalized.split("~");
  const [hours_start, hours_end] = daily!.split("-");
  const [weekend_hours_start, weekend_hours_end] = weekend?.split("-") ?? [];
  return {
    hours_start,
    hours_end,
    ...(weekend ? { weekend_hours_start, weekend_hours_end } : {}),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}
export function withStatisticsHours<T extends { params: object; key: string }>(
  filter: T,
  hours: string | undefined,
) {
  return hours
    ? {
        ...filter,
        params: { ...filter.params, ...statisticsHoursParams(hours) },
        key: `${filter.key}|hours:${hours}`,
      }
    : filter;
}
